<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Novo Comentário
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-textarea
            v-model="description"
            counter
            label="Descrição"
            placeholder="Descrição"
            outlined
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="createFeedbackReportComment()"
          >
            Adicionar Comentário
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {

  props: {
    report: { type: Object, default: () => ({}) }
  },
  data: () => ({
    description: null
  }),
  methods: {
    async createFeedbackReportComment () {
      const data = {
        comment: this.description
      }
      try {
        await this.$api.createFeedbackReportComment(this.report.id, data)
        this.$emit('resolve', true)
      } catch {
      }
    },

    onCancel () {
      this.$emit('resolve', false)
    }
  }
}
</script>
